"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAILS_COPY = void 0;
exports.EMAILS_COPY = {
    urlValidationErrorMsg: "Please provide a valid url that starts with 'http://' or 'https://' and includes a domain extension such as '.com'."
};
